import React, { useState, useEffect } from "react";
import StickBar from "../components/StickBar";
import Header from "../components/Header";
import useScrollPosition from "../hooks/useScrollPosition";
import VideoPlayer from "../components/VideoPlayer";
import {
  getDoc,
  doc,
  getDocs,
  collection,
  query,
  where,
} from "firebase/firestore";
import { db } from "../firebase";
import Carousel from "../components/Carousel";
import Newsletter from "../components/Newsletter";
import BlogCarousel from "../components/BlogCarousel";
import { FiChevronRight } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { SERVER_URL } from "../globalVariables";

const Home = () => {
  const navigate = useNavigate();
  const scroll = useScrollPosition();
  const [showcaseArtworks, setShowcaseArtworks] = useState([]);
  const [blogs, setBlogs] = useState([]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const getShowcaseArtworks = async () => {
      const docRef = doc(db, "selectedArtworks", "showcaseArtworks");
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        setShowcaseArtworks(docSnap.data().artworks);
      } else {
        console.log("No such document!");
      }
    };

    getShowcaseArtworks();
  }, []);

  useEffect(() => {
    const fetchAllBlogs = async () => {
      fetch(`${SERVER_URL}/api/getBlogs`)
        .then((response) => response.json())
        .then((data) => {
          if (data) {
            setBlogs(data?.blogs);
          }
        })
        .catch((error) => {
          console.error("Erreur lors de la récupération des blogs :", error);
        });
    };

    fetchAllBlogs();
  }, []);
  
  return (
    <div>
      <Header isVisible={scroll < 100 ? false : true} logo={true} />

      <div className="flex pt-8">
        <StickBar />

        <div className="w-full lg:pl-[110px]">
          <div className="w-full space-y-16 lg:space-y-24 text-white px-6 md:px-8 lg:px-4">
            <section className="space-y-16">
              <div className="flex w-full justify-center">
                <img
                  className="object-cover max-w-[215px] "
                  src="/images/logo.png"
                />
              </div>

              <Carousel data={showcaseArtworks} />

              <div className="flex w-full lg:justify-center">
                <div className="space-y-4 lg:space-y-0 lg:flex lg:space-x-4 lg:items-center">
                  <img
                    className="object-contain max-w-[180px] "
                    src="/images/logo.png"
                  />

                  <h2 className="text-[28px] md:text-[30px] xl:text-[36px]">
                    is a place dedicated to photography and fine digital art.
                  </h2>
                </div>
              </div>
            </section>

            <section className="space-y-8 w-full">
              <div className="space-y-8">
                <div className="lg:flex space-y-4 lg:space-x-4 items-end leading-none">
                  <h2 className="text-[35px] md:text-[40px] lg:text-[44px] font-medium">
                    Artists
                  </h2>

                  <h4 className="text-[28px]">
                    They are our sponsors and the journey starts with them…
                  </h4>
                </div>

                <div className="space-y-6 lg:space-y-0 lg:flex items-center lg:space-x-7">
                  <div className="text-white space-y-6 w-full lg:max-w-[330px]">
                    <h3 className="text-[36px] font-medium">Ahmed Bahhodh</h3>

                    <h4 className="text-[28px]">Kids Fashion Photographer</h4>

                    <h4 className="text-[21px] italic">
                      ”The pursuit of beauty is an inspiration to live life to
                      its fullest. What is beautiful is never limited by the
                      boundaries of esthetics, but instead inspires our minds to
                      explore the depths of beauty and create something entirely
                      new.”
                    </h4>
                  </div>

                  <VideoPlayer
                    path="/videos/Ahmed Bahhodh.mp4"
                    poster="/images/Ahmed-image-video.png"
                  />
                </div>

                <div className="space-y-6 lg:space-y-0 lg:flex items-center lg:space-x-7">
                  <div className="text-white space-y-6 w-full lg:max-w-[330px]">
                    <h3 className="text-[36px] font-medium">Amaury Soares</h3>

                    <h4 className="text-[28px]">
                      Automotive Artist Photographer
                    </h4>

                    <h4 className="text-[21px] italic">
                      “To reveal everything that is outstanding in every
                      legendary car model”
                    </h4>
                  </div>

                  <VideoPlayer
                    path="/videos/amaury-video.mp4"
                    poster="/images/Amaury-image-video.png"
                  />
                </div>
              </div>
            </section>

            {blogs && blogs.length > 0 && (
              <section className="w-full space-y-8">
                <div className="relative flex justify-between items-center">
                  <h2 className="text-[28px] lg:text-[36px] text-white font-bold w-full leading-none">
                    The Blog
                  </h2>

                  <button
                    className="absolute bottom-0 right-6 md:right-8 flex-none flex items-center group"
                    onClick={() => navigate("/the-blog")}
                  >
                    <span className="text-white group-hover:text-[#33c7b6] transition-colors duration-200">
                      View all
                    </span>

                    <FiChevronRight className="w-6 h-6 text-white pl-1 group-hover:text-[#33c7b6] transition-colors duration-200" />
                  </button>
                </div>

                <BlogCarousel data={blogs} />
              </section>
            )}

            <Newsletter />

            <section className="lg:flex lg:space-x-8 xl:space-x-20 w-full pb-2 lg:pb-16 pr-6 md:pr-8 lg:pr-4">
              <div className="text-white w-full lg:max-w-[400px] xl:max-w-[480px] space-y-4 lg:space-y-8">
                <h2 className="text-[28px] lg:text-[36px] text-white font-bold w-full leading-none">
                  Ambition
                </h2>

                <div className="space-y-4 lg:space-y-8">
                  <p className="text-[20px] lg:text-[24px] xl:text-[28px]">
                    Our ambition is to make creator’s artworks available and
                    promoted, while ensuring the value is secured for the
                    artist.
                  </p>

                  <p className="text-[20px] lg:text-[24px] xl:text-[28px]">
                    We believe this is fondamental to create a fair and
                    sustainable ecosystem that will feed our soul and hearts
                    with original creations, beyond time and space.
                  </p>

                  <button>
                    <a
                      className="underline underline-offset-4"
                      href="https://the-gallery.io/about-us"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Read more
                    </a>
                  </button>
                </div>
              </div>

              <div className="flex relative w-full items-center py-24 sm:py-32 md:py-36 lg:py-0">
                <img
                  className="object-contain max-w-[68%] md:max-w-[69%] xl:max-w-[68%] z-50"
                  src="/images/amaury-soares-ambition.png"
                />

                <img
                  className="absolute object-contain max-w-[45%] md:max-w-[42%] lg:max-w-[45%] xl:max-w-[45%] max-h-[350px] sm:max-h-[450px] md:max-h-[600px] right-0"
                  src="/images/ahmed-ambition.jpeg"
                />
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
